var _circle, _circle2, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToiletCrimson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 2.5,
    r: 2.5,
    fill: "#BC323B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 2.5,
    r: 2.5,
    fill: "#BC323B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 6.44772 0.447715 6 1 6H6C6.55228 6 7 6.44772 7 7V14.5C7 14.7761 6.77614 15 6.5 15H0.5C0.223858 15 0 14.7761 0 14.5V7Z",
    fill: "#BC323B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14H5V18C5 18.5523 4.55228 19 4 19H3C2.44772 19 2 18.5523 2 18V14Z",
    fill: "#BC323B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14H14V18C14 18.5523 13.5523 19 13 19H12C11.4477 19 11 18.5523 11 18V14Z",
    fill: "#BC323B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.948 8.25H14.9553L15.998 14.4131V14.5C15.998 14.7761 15.7742 15 15.498 15H9.49805C9.2219 15 8.99805 14.7761 8.99805 14.5V14.413L10.0408 8.25H10.0481C10.2797 6.96624 11.2886 6 12.498 6C13.7075 6 14.7164 6.96624 14.948 8.25Z",
    fill: "#BC323B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToiletCrimson);
export default __webpack_public_path__ + "static/media/toilet_crimson.01689b0d2bbd14bcd8f2ce5584780013.svg";
export { ForwardRef as ReactComponent };